import { create } from "zustand";
import { track } from "./analytics";

export type OutOfCreditsKind = "ai" | "data";

type OutOfCreditsDialogState = {
  kind: OutOfCreditsKind | null;
  // When the balance refills; shown so the user knows how long the block lasts.
  resetsAt: string | null;
};

type OutOfCreditsDialogActions = {
  openOutOfCreditsDialog: (
    kind: OutOfCreditsKind,
    resetsAt: string | null,
  ) => void;
  closeOutOfCreditsDialog: () => void;
};

export const useOutOfCreditsDialogStore = create<
  OutOfCreditsDialogState & OutOfCreditsDialogActions
>((set) => ({
  kind: null,
  resetsAt: null,
  openOutOfCreditsDialog: (kind, resetsAt) => set({ kind, resetsAt }),
  closeOutOfCreditsDialog: () => set({ kind: null, resetsAt: null }),
}));

export const openOutOfCreditsDialog = (
  kind: OutOfCreditsKind,
  resetsAt: string | null,
) => {
  useOutOfCreditsDialogStore.getState().openOutOfCreditsDialog(kind, resetsAt);
  track("billing.credit_block.shown", { pool: kind });
};
